import * as api from '../logisticsApi';
import {
  call,
  put,
  select,
  takeEvery
  } from 'redux-saga/effects';
import {
  FetchShipmentList,
  IShipmentListItem,
  logisticsActionCreators,
  LogisticsActionKeys
  } from '..';
import {
  FilterTypes,
  getFilteredSalesDistricts,
  getFilters,
  ISalesShipmentFilters
  } from '../../filters';
import { getLogisticsDateRangeString } from '../logisticsSelectors';
import { IState } from '../..';

function* fetchShipmentListSaga(action: FetchShipmentList) {
  const dateRangeString = yield select(getLogisticsDateRangeString);

  let filters: ISalesShipmentFilters = yield select((state: IState) => getFilters(state, FilterTypes.salesShipments));

  const salesDistricts: string[] = yield select((state: IState) => getFilteredSalesDistricts(state, filters));
  filters = { ...filters, salesDistricts };

  yield put(logisticsActionCreators.toggleShipmentListLoading(dateRangeString));
  const items: IShipmentListItem[] = yield call(api.fetchShipmentListItems, filters);

  yield put(logisticsActionCreators.fetchShipmentListFulfilled(items));
  yield put(logisticsActionCreators.toggleShipmentListLoading(dateRangeString));
}

export function* watchFetchShipmentList() {
  yield takeEvery(LogisticsActionKeys.FETCH_SHIPMENT_LIST, fetchShipmentListSaga);
}
